

















































import { Component, Ref, Vue } from 'vue-property-decorator';
import md5 from 'js-md5';
import { AdminUpdatePwd } from '@/http/api/LoginApi';

interface IPasswordData {
  oPassword: string;
  newPassword: string;
  newPasswords: string;
}

@Component
export default class ChangePassword extends Vue {
  @Ref() private passwordForm!: HTMLDataElement;

  private submitting: boolean = false;
  private passwordData: IPasswordData = {
    oPassword: '',
    newPassword: '',
    newPasswords: '',
  };
  private passwordRules: any = {
    oPassword: [
      { required: true, message: '请输入旧密码', trigger: 'blur' },
      { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/, message: '8-16位数字字母组合', trigger: 'blur' },
    ],
    newPassword: [
      { required: true, message: '请输入新密码', trigger: 'blur' },
      { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/, message: '8-16位数字字母组合', trigger: 'blur' },
    ],
    newPasswords: [
      { required: true, message: '请输入确认新密码', trigger: 'blur' },
      { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/, message: '8-16位数字字母组合', trigger: 'blur' },
    ],
  };

  private passwordSubmit(): void {
    if (this.submitting) {
      return;
    }
    (this.passwordForm as any).validate((valid: boolean) => {
      if (!valid) {
        return;
      }
      if (this.passwordData.newPassword !== this.passwordData.newPasswords) {
        this.$message.warning('两次密码要保持一致');
        return;
      }

      this.submitting = true;
      AdminUpdatePwd({
        password: md5(this.passwordData.oPassword),
        newPassword: md5(this.passwordData.newPassword),
      }).then((res) => {
        if (res.code === '000') {
          this.$message.success('修改密码成功');
          (this.passwordForm as any).resetFields();
        }
      }).finally(() => {
        this.submitting = false;
      });
    });
  }
}
